export function pushGTMEvent(event, options = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...options });
}
